import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
import financial from './financial.js'
import analysis from './analysis.js'
import meetings from './meetings.js'
import notification from './notification.js'
import onereports from './onereports.js'
import annualreports from './annualreports.js'
import sustainabilityreport from './sustainabilityreport.js'
import form56 from './form56.js'
import stock from './stock.js'
import newsclippings from './newsclippings.js'
import contact from './contact.js'
import adelectronic from './adelectronic.js'
import calendar from './calendar.js'
import activity from './activity.js'
import securities_analysis from './securities_analysis.js'
import newsmedias from './newsmedias.js'
import credit_ratings from './credit_ratings.js'





export default new Vuex.Store({
    modules: {
        financial,
        analysis,
        meetings,
        notification,
        onereports,
        annualreports,
        sustainabilityreport,
        form56,
        stock,
        newsclippings,
        contact,
        adelectronic,
        calendar,
        activity,
        securities_analysis,
        newsmedias,
        credit_ratings
    }
})
